import { MatTableDataSource } from '@angular/material/table';
import { ObjectPathService } from '../../service/common/deep-path/deep-path.service';
import { Netzbetreiber } from '../../domain/model/netzbetreiber';
import { Kundenbetreuer } from '../../domain/model/kundenbetreuer';
import { Schaltleitung } from '../../domain/model/schaltleitung';

export class NetzbetreiberDataSource extends MatTableDataSource<Netzbetreiber> {

    sortingDataAccessor: ((data: Netzbetreiber, sortHeaderId: string) => string | number) =
        (data: Netzbetreiber, sortHeaderId: string): string | number => {

            const value = ObjectPathService.objectPath(data, sortHeaderId);

            if (value === undefined || value === null) {
                return '';
            }

            if (typeof value === 'string' && !value.trim()) {
                return value;
            }

            if (sortHeaderId === 'netzbetreibernummer') {
                // Vergib mir, denn ich weiss, was ich tue:
                return value.padStart(25, '0');
                // die Sortierung schlaegt bei Mischformen fehl, wenn netzbetreibernummer Buchstaben enthalten
                // wenn man alles auf die gleiche Laenge padded, kann man alles als String sortieren.
            }

            if (sortHeaderId === 'schaltleitungen') {
                if (!value || value.length === 0) {
                    return '';
                }
                return value.map(function (sl) {
                    return sl.name.toLowerCase();
                }).join();
            }

            if (sortHeaderId === 'kundenbetreuerList') {
                return this.joinKundenbetreuer(value);
            }

            return isNaN(+value) ? value.toLowerCase() : +value;
        };

    filterPredicate = (data: Netzbetreiber, filter: string): boolean => {
        if (filter) {
            filter = filter.toLowerCase();
            return (
                data.name && data.name.toLowerCase().indexOf(filter) !== -1 ||
                data.stadtwerkeId && data.stadtwerkeId.toLowerCase().startsWith(filter) ||
                data.teilgebiet && data.teilgebiet.toLowerCase().indexOf(filter) !== -1 ||
                this.joinKundenbetreuer(data.kundenbetreuerList).indexOf(filter) !== -1 ||
                data.netzbetreibernummer && data.netzbetreibernummer.toLowerCase().startsWith(filter) ||
                this.joinSchaltleitungen(data.schaltleitungen).indexOf(filter) !== -1
            );
        }
        return true;
    };

    private joinKundenbetreuer(list: Kundenbetreuer[]): string {
        if (!list || list.length === 0) {
            return '';
        }
        return list.map(function (kb) {
            return (kb.vorname + kb.nachname).toLowerCase();
        }).join();
    }

    private joinSchaltleitungen(list: Schaltleitung[]): string {
        if (!list || list.length === 0) {
            return '';
        }
        return list.map(function (sl) {
            return sl.name.toLowerCase();
        }).join();
    }


}
